const animateImages = () => {
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach((item) => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
				function handleIntersect(entries, observer) {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							let css_classlist = entry.target.classList;
							css_classlist.add("is-inview");

							observer.unobserve(entry.target);

							setTimeout(() => {
								css_classlist.remove("is-inview");
								css_classlist.remove("observe-me");
							}, 1000); // Duration matches the animation duration in SCSS
						}
					});
				}

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0.0,
				};

				let observer = new IntersectionObserver(handleIntersect, options);
				let targets = item.querySelectorAll(".observe-me");
				targets.forEach((target, index) => {
					observer.observe(target);
				});
			}

			createObserver();
		}
	});
};

const loadItems = (button) => {
	const totalPagesInput = document.querySelector("[data-total-pages]");
	const currentPageInput = document.querySelector("[data-current-page]");
	const nextUrlInput = document.querySelector("[data-next-url]");
	if (!totalPagesInput || !currentPageInput || !nextUrlInput) return;

	const totalPages = parseInt(totalPagesInput.value);
	let currentPage = parseInt(currentPageInput.value);
	let currentPageScroll = currentPage + 1;

	currentPage = currentPage + 1;
	const nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, "page=" + currentPage);
	const nextUrlScroll = nextUrlInput.value.replace(
		/page=[0-9]+/,
		"page=" + currentPageScroll
	);
	currentPageInput.value = currentPage;

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	fetch(nextUrl)
		.then((response) => response.text())
		.then((responseHTML) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(responseHTML, "text/html");
			const incomingGrid = doc.querySelector(".load-more-grid");
			const currentGrid = document.querySelector(".load-more-grid");
			if (incomingGrid && currentGrid) {
				currentGrid.insertAdjacentHTML("beforeend", incomingGrid.innerHTML);
			}
			document.dispatchEvent(new CustomEvent("load-more:appended"));
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			if (currentPage <= totalPages) {
				const scollData = document.querySelector(".infinite-scroll__data");
				if (scollData && currentPage != totalPages) {
					scollData.querySelector("input[data-next-url]").dataset.nextUrl =
						nextUrlScroll;
					scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
					scollData.querySelector(
						"input[data-current-page]"
					).dataset.currentPage = currentPage;
					scollData.querySelector("input[data-current-page]").value =
						currentPage;
					checkVisibility();
				}
				button.removeAttribute("disabled");
				button.classList.remove("loading");
				if (currentPage == totalPages) {
					button.remove();
				}

				animateImages();
			}
		});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
					sectionObserver.unobserve(entry.target);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
	animateImages();
}

(function () {
	loadMore();
})();
